import css from './Home.module.css';

const Home = () => {
  return (
    <div className={css.container}>
      <h1 className={css.title}>Welcome PhoneBook</h1>
    </div>
  );
};

export default Home;
